import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DetailedEstimate } from '../../components/estimation/detailed/DetailedEstimate';
import { QuickEstimate } from '../../components/estimation/quick/QuickEstimate';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import ErrorMessage from '../../components/ui/ErrorMessage';

const EditEstimate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [estimate, setEstimate] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const savedEstimate = localStorage.getItem('editEstimate');
    if (!savedEstimate) {
      setError('Estimation non trouvée');
      return;
    }

    try {
      const parsedEstimate = JSON.parse(savedEstimate);
      setEstimate(parsedEstimate);
    } catch (err) {
      setError('Erreur lors du chargement de l\'estimation');
    } finally {
      setLoading(false);
    }
  }, [id]);

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} />;
  if (!estimate) return null;

  // Pour les estimations détaillées
  if (estimate.type === 'detailed') {
    return <DetailedEstimate initialData={estimate} />;
  }

  // Pour les estimations rapides
  return <QuickEstimate initialData={estimate} />;
};

export default EditEstimate;